import lazySizes from 'lazysizes'

Object.assign(lazySizes.cfg, {
  expand: 1000,
  expFactor: 2
})
